import React from 'react';
import { observer } from 'mobx-react-lite';
import { RaceMetaDataWeather } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardMeta/RaceCardMeta.style';

/** Extracts the first number (as a string) from the input text. Returns null if no number is found.
 * @param text - Input string to search for a number.
 * @returns First matched number as a string, or null if not found.
 */
const extractTemperature = (text: string): string | null => {
    const match = /(\d+)/.exec(text);

    return match?.[1] ?? null;
};

interface WeatherTemperaturePropsType {
    value: string;
}

export const WeatherTemperature = observer(({ value }: WeatherTemperaturePropsType) => {
    const temperature = extractTemperature(value);

    return temperature === null ? null : <RaceMetaDataWeather>At race time: {temperature}°C</RaceMetaDataWeather>;
});
